import { render, staticRenderFns } from "./transactionsStatusComponent.vue?vue&type=template&id=020e822b&scoped=true"
import script from "./transactionsStatusComponent.vue?vue&type=script&lang=js"
export * from "./transactionsStatusComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020e822b",
  null
  
)

export default component.exports